/**
 * @file コンポーネント：フル動画ページ編集モーダル症例タグリスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContents = styled.div``;

export const StyledContentsSearch = styled.div`
    display: flex;
    align-items: stretch;
`;

export const StyledContentsSearchItem = styled.div`
    &:first-of-type {
        flex-grow: 1;
        margin-right: 8px;
    }

    & > a {
        display: inline-flex;
        align-items: center;
        height: 100%;
    }
`;

export const StyledContentsSelected = styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px 4px 0;
`;

export const StyledContentsSelectedItem = styled.li`
    margin: 0 8px 8px 0;
`;

export const StyledContentsSelectedItemButton = styled.button`
    display: inline-flex;
    padding: 5px 12px;
    border: 1px solid #5a6063;
    border-radius: 7px;
    background-color: transparent;
    color: #000000;
    font-size: 13px;
    line-height: 16px;
`;

export const StyledContentsSelectedItemButtonIcon = styled.span`
    margin-right: 4px;
`;

export const StyledContentsSelectedItemButtonText = styled.span``;
